module.exports = __webpack_public_path__ + "img/icon_shijianma.699e5430.svg";